import { EntityBase } from './EntityBase';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ClusterNodeAndEdge extends EntityBase {

   /// <code> Place custom code between <code> tags
   /// </code>

   // Generated code. Do not place code below this line.
   id: number;
   clusterGroupId: number;
   clusterPathId: number;
   precedence: number;
   clusterPartNode: string;
   clusterPartLabel: string;
   parentNode: string;
   colorCode: string;
   shapeType: string;
   isMaterial: boolean;
   clusterRelevance: number;
   confidential: number;
   childNodeCountWithConfidential: number;
   childNodeCountWithoutConfidential: number;
}

